import React from 'react';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
}
export function Badge({
  className = '',
  variant = 'default',
  children,
  ...props
}: BadgeProps) {
  const variants = {
    default: 'bg-blue-600 text-white border-transparent',
    secondary: 'bg-slate-100 text-slate-900 border-transparent dark:bg-slate-800 dark:text-slate-100',
    outline: 'bg-transparent border-slate-200 text-slate-900 dark:border-slate-700 dark:text-slate-100',
    destructive: 'bg-red-500 text-white border-transparent'
  };
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${variants[variant]} ${className}`} {...props} data-id="element-297">
      {children}
    </span>;
}